import { render } from "./TheWarning.vue?vue&type=template&id=79e4cf9a&scoped=true&ts=true"
import script from "./TheWarning.vue?vue&type=script&lang=ts"
export * from "./TheWarning.vue?vue&type=script&lang=ts"

import "./TheWarning.vue?vue&type=style&index=0&id=79e4cf9a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e4cf9a"]])

export default __exports__